import _toConsumableArray from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import { FORM_REPOSITORY_WEB_CONFIG } from './form-repository-web.config';
import { apiProviders } from './api.provider';
import { repositoryProviders } from './repository.provider';
import { cachedProviders } from './cached-provider';
import { FormReleaseMapper, formReleaseWebRepositoryProvider } from './repositories';
import { FORM_RELEASE_CACHED_REPOSITORY } from '../core';
import { FORM_RELEASE_API, FormReleaseApi, FormReleaseApiMapper, FormReleaseInMemoryWebCached } from './data-sources';
import { AxiosInstanceBuilder } from '@digibricks/plugin-axios';
import { SectionSummaryApiMapper } from './data-sources/apis/mappers/section-summary-api.mapper';
export var FormRepositoryWebModule = /*#__PURE__*/function () {
  function FormRepositoryWebModule() {
    _classCallCheck(this, FormRepositoryWebModule);
  }

  _createClass(FormRepositoryWebModule, null, [{
    key: "register",
    value: function register(config) {
      return {
        module: FormRepositoryWebModule,
        providers: [{
          provide: FORM_REPOSITORY_WEB_CONFIG,
          useValue: config
        }].concat(_toConsumableArray(apiProviders), _toConsumableArray(cachedProviders), _toConsumableArray(repositoryProviders)),
        exports: _toConsumableArray(repositoryProviders)
      };
    }
  }]);

  return FormRepositoryWebModule;
}();
export var FormReleaseRepositoryWebModule = /*#__PURE__*/function () {
  function FormReleaseRepositoryWebModule() {
    _classCallCheck(this, FormReleaseRepositoryWebModule);
  }

  _createClass(FormReleaseRepositoryWebModule, null, [{
    key: "register",
    value: function register(config) {
      return {
        module: FormReleaseRepositoryWebModule,
        providers: [{
          provide: SectionSummaryApiMapper,
          useValue: new SectionSummaryApiMapper()
        }, {
          provide: FormReleaseApiMapper,
          useFactory: function useFactory(sectionSummaryApiMapper) {
            return new FormReleaseApiMapper(sectionSummaryApiMapper);
          },
          inject: [SectionSummaryApiMapper]
        }, {
          provide: FORM_REPOSITORY_WEB_CONFIG,
          useValue: config
        }, FormReleaseMapper, {
          provide: FORM_RELEASE_CACHED_REPOSITORY,
          useFactory: function useFactory() {
            return new FormReleaseInMemoryWebCached();
          }
        }, {
          provide: FORM_RELEASE_API,
          useFactory: function useFactory(config, formReleaseApiMapper) {
            var axiosInstanceBuilder = new AxiosInstanceBuilder().withBaseUrl(config.baseUrl).withTimeout(config.timeout).withHeaders({
              Authorization: "Bearer ".concat(config.accessToken)
            });
            return new FormReleaseApi(axiosInstanceBuilder.toInstance(), formReleaseApiMapper);
          },
          inject: [FORM_REPOSITORY_WEB_CONFIG, FormReleaseApiMapper]
        }, formReleaseWebRepositoryProvider],
        exports: [formReleaseWebRepositoryProvider]
      };
    }
  }]);

  return FormReleaseRepositoryWebModule;
}();